export default __webpack_public_path__ + "static/media/chat.ac9a7c73.png";